export enum ToolVisibility {
  Private = "Private",
  ReadOnly = "Public Read Only",
  Collaborative = "Public Collaborative",
}
